import { Box, Button, Stack, Typography } from "@mui/material";
import compInfos from "./upload-input.json";
import { useLangContext } from "../../../context/langContext";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useNotificationContext } from "../../../context/notificationContext";

interface IUploadInput {
  id: string;
  setSelectedFile?: (file: File) => void;
  handleChangeFile?: (file: File) => void;
  removeFile?: () => void;
  accept?: "excel" | "images" | "audio";
  maxSize?: number;
}

const fileRejectError = {
  fa: "فایل با حجم یا نوع نادرست.",
  en: "Invalid file type or size.",
};

const accentFile = {
  excel: {
    "application/vnd.ms-excel": [],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
  },
  audio: {
    // "audio/mpeg": [], // .mp3
    "audio/wav": [], // .wav
    // "audio/ogg": [], // .ogg
    // "audio/flac": [], // .flac
  },
  images: {
    "image/jpeg": [], // .jpg, .jpeg
    "image/png": [], // .png
    "image/gif": [], // .gif
    "image/webp": [], // .webp
    "image/svg+xml": [], // .svg
  },
};

export default function UploadInput({
  id,
  setSelectedFile,
  handleChangeFile,
  removeFile,
  accept = "excel",
  maxSize = 5000000,
}: Readonly<IUploadInput>) {
  const { lang } = useLangContext();
  const { setNotification } = useNotificationContext();
  const inputRef = useRef<any>();
  const infos = compInfos[lang];
  const onDrop = useCallback((acceptedFiles: File[], fileRejections: any) => {
    console.error(fileRejections);
    if (fileRejections.length > 0) {
      setNotification({ type: "error", message: fileRejectError[lang] });
      return;
    }
    handleChangeFile && handleChangeFile(acceptedFiles[0]);
    setFiles(acceptedFiles);
    console.log(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      ...accentFile[accept],
    },
    maxSize: maxSize ? maxSize : 5000000,
  });

  const [files, setFiles] = useState<File[]>([]);

  const handleRemoveFile = () => {
    setFiles([]);
    removeFile && removeFile();
  };

  const handleChangeFileClick = () => {
    handleRemoveFile();
    // inputRef.current?.click();
  };

  useEffect(() => {
    setSelectedFile && setSelectedFile(files[0]);
  }, [files]);

  return (
    <Box
      // {...getRootProps()}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        borderColor: (theme) => theme.palette.complement[400],
        borderWidth: "1px",
        borderStyle: "dashed",
        padding: "27px 41px",
        mt: "24px",
        borderRadius: "2px",
        cursor: "pointer",
        backgroundColor: (theme) => theme.palette.complement[100],
      }}
    >
      <input
        ref={inputRef}
        type="file"
        hidden
        id={`input-file-${id}`}
        style={{ display: "none" }}
        {...getInputProps()}
      />
      {files.length === 0 ? (
        <Box
          {...getRootProps()}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          component={"label"}
          // htmlFor={`input-file-${id}`}
        >
          <Stack mb="24px">
            <img
              src="/images/upload.svg"
              alt="Upload"
              width="45px"
              height="45px"
            />
          </Stack>
          <Typography
            variant="footerMediumBold"
            color={(theme) => theme.palette.dominant[400]}
            sx={{
              textAlign: "center",
            }}
          >
            {infos.title}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Stack mb="24px">
            <img
              src="/images/audioFile.svg"
              alt="Upload"
              width="45px"
              height="45px"
            />
          </Stack>
          <Typography
            variant="footerMediumBold"
            color={(theme) => theme.palette.dominant[400]}
            sx={{
              textAlign: "center",
            }}
          >
            {files[0].name}
          </Typography>
          <Typography
            variant="footerMediumBold"
            color={(theme) => theme.palette.dominant[400]}
            sx={{
              textAlign: "center",
            }}
          >
            size: {files[0].size / 1000} KB
          </Typography>

          <Stack direction="row" gap="20px" mt={"10px"}>
            <Button onClick={handleRemoveFile} variant="activeOutlined">
              {infos.delButton}
            </Button>
            <Button onClick={handleChangeFileClick} variant="active">
              {infos.changeButton}
            </Button>
          </Stack>
        </Box>
      )}
    </Box>
  );
}
